const colorPalette = [
    '#FF5733',
    '#4CAF50',
    '#2196F3',
    '#FFC107',
    '#E91E63',
    '#795548',
    '#FF9800',
    '#607D8B',
    '#9C27B0',
    '#8BC34A',
    '#FF5722',
    '#00BCD4',
    '#FFEB3B',
    '#9E9E9E',
    '#FF5252',
    '#00E676',
    '#3F51B5',
    '#FF4081',
    '#8BC34A',
    '#FFD740',
    '#795548',
    '#4CAF50',
    '#2196F3',
    '#E91E63',
    '#9C27B0',
    '#FF9800',
    '#00BCD4',
    '#FFC107',
    '#8BC34A',
    '#FF5733',
    '#3F51B5',
    '#FF4081',
    '#795548',
    '#9E9E9E',
    '#FF5252',
    '#00E676',
    '#4CAF50',
    '#8BC34A',
    '#FF9800',
    '#2196F3',
    '#FF5733',
    '#FFC107',
    '#E91E63',
    '#9C27B0',
    '#795548',
];

export default colorPalette;
